import { getClient } from './http-client'

interface FeatureFlag {
  enabled: boolean
  key: string
  description?: string
}

interface PublicFeatureFlagsResponse {
  feature_flags: Record<string, FeatureFlag>
}

class PublicFeatureFlagsService {
  private flags: Record<string, FeatureFlag> = {}
  private loading = false
  private loaded = false

  async loadFlags(): Promise<void> {
    if (this.loaded || this.loading) {
      return
    }

    this.loading = true

    try {
      const client = getClient()
      const response = await client.get<PublicFeatureFlagsResponse>(
        '/preferences/public/feature-flags/'
      )
      this.flags = response.data.feature_flags || {}
      this.loaded = true
    } catch (error) {
      console.error('Failed to load public feature flags:', error)
      // Fail silently, flags will be disabled by default
    } finally {
      this.loading = false
    }
  }

  isEnabled(flagKey: string): boolean {
    const flag = this.flags[flagKey]
    const enabled = flag?.enabled ?? false
    return enabled
  }

  // Initialize on import
  async initialize() {
    await this.loadFlags()
  }
}

// Create singleton instance
export const publicFeatureFlags = new PublicFeatureFlagsService()
